import { render, staticRenderFns } from "./CodigoBarras.vue?vue&type=template&id=6cffd582&"
import script from "./CodigoBarras.vue?vue&type=script&lang=js&"
export * from "./CodigoBarras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports